(function () {
    'use strict';

    angular
        .module('bcmRoutes', [
            'BCMControllers',
            'bcmModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

            // BIA Profile Home
            .state('biaProfile', {
                url: '/BCM/BIAProfile',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                data: {
                    breadcrumb: {
                        title: 'Overview',
                        cssIcon: 'fa fa-search',
                        usingHistoryCtxt: true,
                        defaultCtxtState: 'newBIAProfileSearch',
                    }
                },
                abstract: true,
                views: {
                    '': {
                        template: '<div class="row"><div ui-view="breadcrumbs" class="breadcrumbs-container no-margin no-padding"></div>' +
                                  '<div ui-view="main" class="margin-xl-v bcm"></div></div>',
                        controller: 'BIAProfileListController'
                    },
                    'breadcrumbs@biaProfile': {
                        templateUrl: require('./biaBreadcrumbs.tpl.html')
                    }
                }
            })

            // BIA Profile Add
            .state('biaProfile.add', {
                url: '/Add',
                data: {
                    permissions: { featureRole: 'BCMManagement', key: 'BIAProfile', permission: 'Create' },
                },
                views: {
                    'main@biaProfile': {
                        resolve: {
                            biaProfileContainer: function () {
                                return {};
                            },
                            followUps: function () {
                                return null;
                            },
                            biaResponsibilities: function () {
                                return [];
                            }  ,
                            bcmLookups: function () {
                                return null;
                            }
                        },
                        templateUrl: require('./biaProfileAdd.tpl.html'),
                        controller: 'BIAProfileEditController'
                    }
                }
            })

            // Welcome page for BC Coordinator
            .state('biaProfile.welcomeBCC', {
                url: '/Welcome/Coordinator?biaProfileId',
                data: {
                    breadcrumb: {
                        title: 'Welcome',
                        showWhenActive: true
                    }
                },
                views: {
                    'main@biaProfile': {
                        templateUrl: require('./biaProfileIntroduction.coordinator.tpl.html'),
                        controller: 'BIAProfileIntroductionController'
                    }
                }
            })

            // BIA Profile Edit
            .state('biaProfile.edit', {
                url: '/{BIAProfileID:int}',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                data: {
                    breadcrumb: {
                        titlePath: 'biaProfile.TitleEN',
                        title: 'BC Analysis',
                        cssIcon: 'fa fa-umbrella',
                        stateReload: true,
                        showWhenActive: true
                    }
                },
                resolve: {
                    biaProfileContainer: ['$state', '$stateParams', 'biaProfileService', '$q', 'authenticatedUser', function ($state, $stateParams, service, $q, authenticatedUser) {
                        return service
                            .getBIAProfileContainer($stateParams.BIAProfileID)
                            .then(function(biaProfileContainer) {
                                return biaProfileContainer;
                            }, function () {
                                // BIA Profile not found, go to home page
                                $state.go('home', { UserItemPersonID: authenticatedUser.ItemPersonID });

                                // Return rejected promise
                                return $q.reject();
                            });
                    }],
                    hasVisitedWelcome: ['$q', '$state', '$stateParams', 'itemTaskService', 'biaProfileContainer', function ($q, $state, $stateParams, service, biaProfileContainer) {
                        if (!biaProfileContainer.BIAProfile.IsBusinessContinuityCoordinator) return true;

                        return service
                            .getItemTaskByNameForUser('NeedBCCExplanationAcknowledgement')
                            .then(function (itemTask) {
                                if (itemTask && itemTask.IsDone) {
                                    return true;
                                }

                                // Go to Welcome page
                                $state.go('biaProfile.welcomeBCC', { biaProfileId: biaProfileContainer.BIAProfile.BIAProfileID });

                                // Return rejected promise
                                return $q.reject();
                            });
                    }],
                    biaResponsibilities: ['$stateParams', 'biaResponsibilityService', function ($stateParams, service) {
                        return service.getBIAResponsibilities($stateParams.BIAProfileID);
                    }],
                    bcmLookups: ['bcmService', function (bcmService) {
                        return bcmService.getBCMLookups();
                    }],
                    followUps: ['$stateParams', 'biaProfileService', function ($stateParams, service) {
                        return service.getFollowUpListByBIAProfileID($stateParams.BIAProfileID);
                    }],
                    permissions: ['permissionService', 'biaProfileContainer', function (permissionService, biaProfileContainer) {
                        return biaProfileContainer
                            && biaProfileContainer.BIAProfile
                            && (biaProfileContainer.BIAProfile.HasBIAProfile_Edit
                                || biaProfileContainer.BIAProfile.HasBIAProfile_Edit_Related);
                    }]
                },
                views: {
                    'breadcrumbs@biaProfile': {
                        templateUrl: require('./biaBreadcrumbs.tpl.html'),
                        controller: 'BIAProfileEditBreadcrumbController'
                    },
                    'main@biaProfile': {
                        templateUrl: require('./biaProfileEdit.tpl.html'),
                        controller: 'BIAProfileEditController'
                    }
                }
            })

            // BIA Profile BIA Responsibility Edit
            .state('biaProfile.edit.biaResponsibility', {
                url: '/BIAResponsibility/{BIAResponsibilityID:int}',
                resolve: {
                    biaResponsibilityContainer: ['$stateParams', 'biaResponsibilityService', function ($stateParams, service) {
                        return service.getBIAResponsibilityContainer($stateParams.BIAProfileID, $stateParams.BIAResponsibilityID);
                    }]
                },
                views: {
                    'main@biaProfile': {
                        templateUrl: require('./biaResponsibilityEdit.tpl.html'),
                        controller: 'BIAResponsibilityEditController'
                    }
                }
            })

            // BU Owner Edit
            .state('biaProfile.edit.biaBuOwner', {
                url: '/BIABUOwner/{BIABUOwnerID:int}',
                data: {
                    breadcrumb: {
                        title: 'Business Unit',
                        cssIcon: 'fa fa-university',
                        reload: true,
                        showWhenActive: true
                    }
                },
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                resolve: {
                    biaBuOwnerContainer: ['$stateParams', 'biaBuOwnerService', function ($stateParams, service) {
                        return service.getBIABUOwnerContainer($stateParams.BIAProfileID, $stateParams.BIABUOwnerID);
                    }]
                },
                views: {
                    'main@biaProfile': {
                        templateUrl: require('./biaBUOwnerEdit.tpl.html'),
                        controller: 'BIABUOwnerEditController'
                    }
                }
            })

            // BU Owner Edit Add BIA Responsibilities
            .state('biaProfile.edit.biaBuOwner.addBIAResponsibilities', {
                template: '',
                data: {
                    breadcrumb: null
                },
                resolve: {
                    modal: function () {
                        return {}
                    }
                },
                onEnter: ['$rootScope', '$modal', '$state', 'biaProfileContainer', 'biaBuOwnerContainer', 'modal',
                    function ($rootScope, $modal, $state, biaProfileContainer, biaBuOwnerContainer, modal) {

                        // Modal to show
                        var modalScope        = $rootScope.$new(true);
                        modalScope.biaProfile = biaProfileContainer.BIAProfile;
                        modalScope.biaBuOwner = biaBuOwnerContainer.BIABUOwner;

                        modalScope.onModalClose = function () {
                            $state.go('^');
                        };

                        modalScope.$on('modal.hide', function () {
                            modalScope.$destroy();

                            if (_.isNil(modal.instance)) return;

                            if ($state.is('biaProfile.edit.biaBuOwner.addBIAResponsibilities')) {
                                $state.go('^');
                            }
                        });

                        modal.instance = $modal({
                            scope: modalScope,
                            template: '/app/Main/BCM/biaBUOwnerEditAddBIAResponsibilities.modal.tpl.html',
                            placement: 'center',
                            backdrop: 'static'
                        });
                    }],
                onExit: ['modal', function (modal) {
                    if (!_.isNil(modal.instance)) {
                        modal.instance.$promise.then(function () {
                            modal.instance.hide();
                            modal.instance = null;
                        });
                    }
                }],
            })

            // BIA Responsibility Edit
            .state('biaProfile.edit.biaBuOwner.biaResponsibility', {
                url: '/BIAResponsibility/{BIAResponsibilityID:int}',
                data: {
                    breadcrumb: {
                        title: 'Responsibility',
                        cssIcon: 'fa fa-shield',
                        reload: true,
                        showWhenActive: true
                    }
                },
                resolve: {
                    biaResponsibilityContainer: ['$stateParams', 'biaResponsibilityService', function ($stateParams, service) {
                        return service.getBIAResponsibilityContainer($stateParams.BIAProfileID, $stateParams.BIAResponsibilityID);
                    }]
                },
                views: {
                    'main@biaProfile': {
                        templateUrl: require('./biaResponsibilityEditForBUOwner.tpl.html'),
                        controller: 'BIAResponsibilityEditForBuOwnerController'
                    }
                }
            })

            // BIA Responsibility Edit BIA Responsibility
            .state('biaProfile.edit.biaBuOwner.biaResponsibility.editBIAResponsibility', {
                template: '',
                data: {
                    breadcrumb: null
                },
                resolve: { modal: function () { return {} } },
                onEnter: ['$rootScope', '$modal', '$state', 'biaResponsibilityContainer', 'modal',
                    function ($rootScope, $modal, $state, biaResponsibilityContainer, modal) {

                        // Modal to show
                        var modalScope               = $rootScope.$new(true);
                        modalScope.biaResponsibility = _.cloneDeep(biaResponsibilityContainer.BIAResponsibility);

                        modalScope.onModalClose = function () {
                            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility');
                        };

                        modalScope.$on('modal.hide', function () {
                            modalScope.$destroy();

                            if (_.isNil(modal.instance)) return;

                            if ($state.is('biaProfile.edit.biaBuOwner.biaResponsibility.editBIAResponsibility')) {
                                $state.go('^');
                            }
                        });

                        modal.instance = $modal({
                            scope: modalScope,
                            template: '/app/Main/BCM/editBIAResponsibility.modal.tpl.html',
                            placement: 'center',
                            backdrop: 'static'
                        });
                    }],
                onExit: ['modal', function (modal) {
                    if (!_.isNil(modal.instance)) {
                        modal.instance.$promise.then(function () {
                            modal.instance.hide();
                            modal.instance = null;
                        });
                    }
                }],
            })

            // BIA Responsibility Edit Special Needs
            .state('biaProfile.edit.biaBuOwner.biaResponsibility.editSpecialNeeds', {
                template: '',
                data: {
                    breadcrumb: null
                },
                resolve: { modal: function () { return {} } },
                onEnter: ['$rootScope', '$modal', '$state', 'biaResponsibilityContainer', 'modal',
                    function ($rootScope, $modal, $state, biaResponsibilityContainer, modal) {

                        // Modal to show
                        var modalScope = $rootScope.$new(true);
                        modalScope.boxModel = _.cloneDeep(biaResponsibilityContainer.BIAResponsibility);

                        modalScope.onModalClose = function () {
                            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility');
                        };

                        modalScope.$on('modal.hide', function () {
                            modalScope.$destroy();

                            if (_.isNil(modal.instance)) return;

                            if ($state.is('biaProfile.edit.biaBuOwner.biaResponsibility.editSpecialNeeds')) {
                                $state.go('^');
                            }
                        });

                        modal.instance = $modal({
                            scope: modalScope,
                            template: '/app/shared/BCM/BIAResponsibility/biaResponsibility.editSpecialNeeds.modalContent.tpl.html',
                            placement: 'center',
                            backdrop: 'static'
                        });
                    }],
                onExit: ['modal', function (modal) {
                    if (!_.isNil(modal.instance)) {
                        modal.instance.$promise.then(function () {
                            modal.instance.hide();
                            modal.instance = null;
                        });
                    }
                }],
            })

            // BIA Responsibility Edit Ratings
            .state('biaProfile.edit.biaBuOwner.biaResponsibility.editRatings', {
                template: '',
                data: {
                    breadcrumb: null
                },
                resolve: {
                    modal: function () { return {} },
                    lookupAttributes: ['adminReferenceDataService', function (service) {
                        return service.getLookupAttributeValues('BIAResponsibility');
                    }]
                },
                onEnter: ['$rootScope', '$modal', '$state', 'biaProfileContainer', 'biaResponsibilityContainer', 'modal', 'lookupAttributes',
                    function ($rootScope, $modal, $state, biaProfileContainer, biaResponsibilityContainer, modal, lookupAttributes) {

                        // Modal to show
                        var modalScope               = $rootScope.$new(true);
                        modalScope.biaResponsibility = _.cloneDeep(biaResponsibilityContainer.BIAResponsibility);
                        modalScope.biaProfile        = biaProfileContainer.BIAProfile;
                        modalScope.biaResponsibilityImpactLevels =
                            lookupAttributes.BIAResponsibilityImpactLevel.LookupAttributeValues;

                        modalScope.onModalClose = function () {
                            $state.go('biaProfile.edit.biaBuOwner.biaResponsibility', {}, {reload: true});
                        };

                        modalScope.$on('modal.hide', function () {
                            modalScope.$destroy();

                            if (_.isNil(modal.instance)) return;

                            if ($state.is('biaProfile.edit.biaBuOwner.biaResponsibility.editRatings')) {
                                $state.go('^');
                            }
                        });

                        modal.instance = $modal({
                            scope: modalScope,
                            template: '/app/Main/BCM/editBIAResponsibilityRatings.modal.tpl.html',
                            placement: 'center',
                            backdrop: 'static'
                        });
                    }],
                onExit: ['modal', function (modal) {
                    if (!_.isNil(modal.instance)) {
                        modal.instance.$promise.then(function () {
                            modal.instance.hide();
                            modal.instance = null;
                        });
                    }
                }],
            })

            .state('biaProfileSummary', {
                url: '/BCM/BIAProfile/{BIAProfileID:int}/Summary',
                data: {
                    breadcrumb: {
                        title: 'Business Continuity Analysis',
                        cssIcon: 'fa fa-clipboard',
                        showWhenActive: true
                    }
                },
                resolve: {
                    biaSummaryContainer: ['$stateParams', 'biaProfileService', function ($stateParams, service) {
                        return service.getBIASummaryContainer($stateParams.BIAProfileID);
                    }],
                    followUps: ['$stateParams', 'biaProfileService', function ($stateParams, service) {
                        return service.getFollowUpListByBIAProfileID($stateParams.BIAProfileID);
                    }],
                    bcmLookups: ['bcmService', function (bcmService) {
                        return bcmService.getBCMLookups();
                    }],
                    permissions: ['biaSummaryContainer', function (biaSummaryContainer) {
                        return biaSummaryContainer.HasBIASummary_View;
                    }]
                },
                views: {
                    '': {
                        template: '<div class="row"><div ui-view="breadcrumbs" class="breadcrumbs-container"></div>' +
                        '<div ui-view="main" class="margin-xl-bottom bcm"></div></div>',
                        controller: 'BIAProfileListController'
                    },
                    'breadcrumbs@biaProfileSummary': {
                        templateUrl: require('./biaBreadcrumbs.tpl.html')
                    },
                    'main@biaProfileSummary': {
                        templateUrl: require('./biaProfileSummary.tpl.html'),
                        controller: 'BIAProfileSummaryController'
                    }
                }
            });
    }
})();
